import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getFeedTemplateKinds} from '../../../apis/feed/getFeedTemplateKinds'
import {EDITOR_CONTRACT} from '../../../pages/feed/constants'
import {IFeedTemplateContract} from '../../../pages/feed/types'

// 에디터 계약(kinds) 조회. 응답 전/실패 시 constants의 EDITOR_CONTRACT를 폴백으로 사용한다.
const useQueryFeedTemplateKinds = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.feed.getFeedTemplateKinds(),
        queryFn: async () => {
            const {data} = await getFeedTemplateKinds()
            return data as IFeedTemplateContract
        },
        refetchOnWindowFocus: false,
    })

    return {contract: data ?? EDITOR_CONTRACT, refetch}
}

export default useQueryFeedTemplateKinds
